import React, { useEffect, useState } from "react";
import Title from "../../extra/Title";
import Button from "../../extra/Button";
import Pagination from "../../extra/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import CoinPackageDialog from "./CoinPackageDialog";
import { getCoinPackage, deleteCoinPackage } from "../../store/coinPackage/coinPackage.action";
import { warning } from "../../../util/Alert";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const CoinPackage = () => {
  const dispatch = useDispatch();
  const { coinPackage } = useSelector((state) => state.coinPackage);
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    dispatch(getCoinPackage());
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
  }, [dispatch]);

  useEffect(() => {
    setData(coinPackage);
  }, [coinPackage]);

  const handleOpenDialog = (data) => {
    // The dialog reducer reads payload.data. Passing the row directly left the
    // dialog empty: Edit opened a blank form and Save CREATED a new package
    // (2026-10-04, boss: "coin prices are not editable").
    dispatch({ type: OPEN_DIALOGUE, payload: { type: "coinPackage", data } });
  };

  const handleDelete = (id) => {
    const data = warning("Delete", "Are you sure you want to delete this coin package?");
    data
      .then((isDeleted) => {
        if (isDeleted) {
          dispatch(deleteCoinPackage(id));
        }
      })
      .catch((err) => console.log(err));
  };

  const indexOfLastPost = currentPage * rowsPerPage;
  const indexOfFirstPost = indexOfLastPost - rowsPerPage;
  const currentPosts = data.slice(indexOfFirstPost, indexOfLastPost);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <div className="mainCategory">
        <Title name="Coin Packages" />
        <div className="row">
          <div className="col-12 col-md-6 col-lg-12 mt-3 mb-3 d-flex justify-content-end">
            <Button
              newClass={`themeFont bg-gradient-primary`}
              btnColor={`btnBlackPrime text-white`}
              btnIcon={`fa-solid fa-plus`}
              btnName={`Add`}
              onClick={() => handleOpenDialog("")}
              style={{ borderRadius: "5px" }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-12 mt-3">
            <div className="customTable">
              <div className="primeMain">
                <table width="100%" className="primeTable text-center">
                  <thead className="sticky-top" style={{ top: "-1px", zIndex: "1" }}>
                    <tr>
                      <th className="fw-bold py-3" style={{ width: "5%" }}>No</th>
                      <th className="fw-bold py-3" style={{ width: "15%" }}>Package Name</th>
                      <th className="fw-bold py-3" style={{ width: "12%" }}>Coins</th>
                      <th className="fw-bold py-3" style={{ width: "12%" }}>Price (USD)</th>
                      <th className="fw-bold py-3" style={{ width: "10%" }}>Discount</th>
                      <th className="fw-bold py-3" style={{ width: "10%" }}>Popular</th>
                      <th className="fw-bold py-3" style={{ width: "8%" }}>Order</th>
                      <th className="fw-bold py-3" style={{ width: "10%" }}>Status</th>
                      <th className="fw-bold py-3" style={{ width: "9%" }}>Edit</th>
                      <th className="fw-bold py-3" style={{ width: "9%" }}>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <>
                        {Array.from({ length: 10 }).map((_, index) => (
                          <tr key={index}>
                            <td><Skeleton /></td>
                            <td><Skeleton /></td>
                            <td><Skeleton /></td>
                            <td><Skeleton /></td>
                            <td><Skeleton /></td>
                            <td><Skeleton /></td>
                            <td><Skeleton /></td>
                            <td><Skeleton /></td>
                            <td><Skeleton /></td>
                            <td><Skeleton /></td>
                          </tr>
                        ))}
                      </>
                    ) : (
                      <>
                        {currentPosts.length > 0 ? (
                          <>
                            {currentPosts.map((data, index) => {
                              return (
                                <tr key={index}>
                                  <td className="text-white">{indexOfFirstPost + index + 1}</td>
                                  <td className="text-white">{data?.name}</td>
                                  <td>
                                    <span className="badge bg-info text-white">
                                      {data?.coins} Coins
                                    </span>
                                  </td>
                                  <td className="text-white">
                                    <span className="fw-bold">
                                      ${data?.price?.toFixed(2)} <small className="text-muted">(= {data?.coins?.toLocaleString()} coins)</small>
                                    </span>
                                  </td>
                                  <td>
                                    {data?.discount > 0 ? (
                                      <span className="badge bg-success">
                                        {data?.discount}% OFF
                                      </span>
                                    ) : (
                                      <span className="text-muted">-</span>
                                    )}
                                  </td>
                                  <td>
                                    {data?.isPopular ? (
                                      <span className="badge bg-warning text-dark">
                                        <i className="fa-solid fa-star me-1"></i>
                                        Popular
                                      </span>
                                    ) : (
                                      <span className="text-muted">-</span>
                                    )}
                                  </td>
                                  <td className="text-white">{data?.order}</td>
                                  <td>
                                    {data?.isActive ? (
                                      <span className="badge bg-success">Active</span>
                                    ) : (
                                      <span className="badge bg-danger">Inactive</span>
                                    )}
                                  </td>
                                  <td>
                                    <Button
                                      newClass={`boxCenter userBtn fs-5 text-white`}
                                      btnColor={`bg-info`}
                                      btnIcon={`far fa-edit`}
                                      onClick={() => handleOpenDialog(data)}
                                      style={{ borderRadius: "5px" }}
                                    />
                                  </td>
                                  <td>
                                    <Button
                                      newClass={`boxCenter userBtn fs-5 text-white`}
                                      btnColor={`bg-danger`}
                                      btnIcon={`fa-solid fa-trash-alt`}
                                      onClick={() => handleDelete(data._id)}
                                      style={{ borderRadius: "5px" }}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </>
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center text-white">
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {/* Was wired with props the shared control does not have
                (totalPosts/paginate/currentPage), so it never rendered and only
                the first page of rows was reachable (2026-09-30). */}
            <Pagination
              component="div"
              type={"client"}
              count={data.length}
              totalData={data.length}
              serverPage={currentPage - 1}
              serverPerPage={rowsPerPage}
              onPageChange={(_e, p) => setCurrentPage(p + 1)}
              onRowsPerPageChange={(v) => {
                setRowsPerPage(parseInt(v, 10) || 25);
                setCurrentPage(1);
              }}
              rowsPerPageOptions={[25, 50, 100, 500]}
            />
          </div>
        </div>
      </div>
      {/* only this page's dialog, not e.g. the header Notification one */}
      {dialogue && dialogueType === "coinPackage" && <CoinPackageDialog />}
    </>
  );
};

export default CoinPackage;
